import React from "react";
import { useNavigate } from "react-router-dom";
import SearchBox from "../../components/SearchBox/SearchBox";
import styles from "./Banner.module.css";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import { useAuth } from "../../context/AuthContext";

const HeroActions = ({ navigate, addClass }) => {
  const { setAuthModal, userdata } = useAuth();

  const handleBecomePartner = () => {
    if (userdata) {
      // User is logged in, redirect to appropriate dashboard
      if (userdata.role === 'institution') {
        navigate('/dashboard/institution');
      } else {
        navigate(`/dashboard/${userdata.role}`);
      }
    } else {
      // User is not logged in, open signup popup
      setAuthModal({ open: true, tab: "signup" });
    }
  };

  const handleBecomeMember = () => {
    if (userdata) {
      // User is logged in, redirect to appropriate dashboard
      if (userdata.role === 'institution') {
        navigate('/dashboard/institution');
      } else {
        navigate(`/dashboard/${userdata.role}`);
      }
    } else {
      // User is not logged in, open signup popup
      setAuthModal({ open: true, tab: "signup" });
    }
  };

  return (
    <div className={`${styles.heroActions} ${addClass && styles.showMobile}`}>
      <button onClick={() => navigate("/mentors")} className={styles.button}>
        Find a Mentor
      </button>
      <button
        onClick={handleBecomePartner}
        className={styles.button}
      >
        Become a Partner
      </button>
      <button
        onClick={handleBecomeMember}
        className={styles.button}
      >
        Become a Member
      </button>
    </div>
  );
};

export default function Banner() {
  const navigate = useNavigate();

  const handleSearch = (query) => {
    navigate(`/mentors?q=${encodeURIComponent(query)}`);
  };
  const { response, loading, error } = useApi(API_ENDPOINTS.HOME_TRUSTED_BY);
  const apiData = response ? response.trustedBy : [];
  const {
    response: bannerData,
    loading: bannerLoading,
    error: bannerError,
  } = useApi(API_ENDPOINTS.HOME_BANNER);
  const bannerApiData = bannerData?.homePageBanner[0] ?? {};
  return (
    <section className={styles.hero}>
      <div
        className={styles.container}
        style={{
          backgroundImage: `url("${process.env.REACT_APP_ASSETS_BASE_URL || "https://api.imparc.site/assets/uploads/"}${bannerApiData.image}")`,  
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className={styles.heroText}>
          {bannerLoading ? (
            <Loader />
          ) : bannerError ? (
            <ErrorMsg />
          ) : (
            <>
              <ColoredWords text={bannerApiData && bannerApiData.heading} />

              <p>{bannerApiData && bannerApiData.sub_heading}</p>
            </>
          )}
          <div>
            <SearchBox
              placeholder="Search by Expert..."
              onSearch={handleSearch}
            />
          </div>
          <HeroActions navigate={navigate} />

        </div>
        <h2>Knowledge Partners</h2>
        <div className={styles.trustedContainer}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData && apiData.map((item) => (
              <div className={styles.imgBox} key={item.id}>
                {/* <img key={item.id} src={item.logo} alt={item.label} /> */}
                <img key={item.id} src={item.logo} alt={item.label} />
              </div>
            ))
          )}
        </div>
        <HeroActions navigate={navigate} addClass={true} />
      </div>
    </section>
  );
}

const ColoredWords = ({ text }) => {
  const parts = text.split(/\s+/); // split on whitespace

  return (
    <h1>
      {parts.map((w, i) => (
        // keep trailing space by adding a space after each word
        <span
          key={i}
          style={
            i === 1 ? { color: "#35bcdb" } : i === 2 ? { color: "#f7a537" } : {}
          }
        >
          {w}
          {i < parts.length - 1 ? " " : ""}
        </span>
      ))}
    </h1>
  );
};
